module.exports = __webpack_public_path__ + "static/media/eye.27045112.svg";